import { Component, OnInit } from '@angular/core';
import { TestsService } from '../../Services/Tests/TestsService';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { Router } from '@angular/router';
import { BuyerTest } from '../../../Models/Tests/tests.models';

@Component({
  selector: 'app-conferenceleaderboard',
  templateUrl: './conferenceleaderboard.component.html',
  styleUrls: ['./conferenceleaderboard.component.scss']
})
export class ConferenceleaderboardComponent implements OnInit {

  constructor(private testsService: TestsService, private route: ActivatedRoute, private router: Router)
  {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url !== this.currentUrl) {
          this.timeLeft = null;
          clearInterval(this.interval);
        }
      }
    });
  }

  timeLeft: number = 180;
  interval;
  currentUrl: string;
  pathId: string;
  pageLength: number;
  skipLength: number; 
  topTestsCollectionSize: number;
  topTests: BuyerTest[] = [];
  dataLoaded: boolean;

  ngOnInit() {
    this.currentUrl = window.location.href;
    this.dataLoaded = false;
    this.pageLength = 50;
    this.skipLength = 0;
    let waitTime = 1000;
    new Promise<void>(resolve => setTimeout(() => resolve(), waitTime)).then(() =>
    this.getConferenceLeaderboard());
  }


  getConferenceLeaderboard() {
    this.testsService.getConferenceLeaderboard(this.skipLength, this.pageLength).subscribe((res) => {
      this.topTests = res.BuyerTests;
      this.topTestsCollectionSize = res.TotalRows;
      this.dataLoaded = true;
      this.startTimer();
    })
  }

  topTestspageChanged(number) {
    if (number === 1) {
      this.skipLength = 0;
    }
    else {
      this.skipLength = (number - 1) * this.pageLength;
    }
    this.getConferenceLeaderboard();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        if (this.timeLeft === 0) {
          this.timeLeft = 180;
          this.getConferenceLeaderboard();
        }
      }
    }, 1000)
  }
}
